import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-169de708"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-container",
  ref: "container"
};
const _hoisted_2 = {
  class: "assembly"
};
const _hoisted_3 = {
  class: "setw",
  ref: "picture"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = ["id"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#49a2fe"
  }
}, "由浩跃提供技术支持", -1));
const _hoisted_9 = [_hoisted_8];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_title_assembly = _resolveComponent("title-assembly");
  const _component_rich_assembly = _resolveComponent("rich-assembly");
  const _component_picture_assembly = _resolveComponent("picture-assembly");
  const _component_graph_assembly = _resolveComponent("graph-assembly");
  const _component_atlas_assembly = _resolveComponent("atlas-assembly");
  const _component_video_assembly = _resolveComponent("video-assembly");
  const _component_form_assembly = _resolveComponent("form-assembly");
  const _component_telephone_assembly = _resolveComponent("telephone-assembly");
  const _component_qrcode_assembly = _resolveComponent("qrcode-assembly");
  const _component_popup_picture = _resolveComponent("popup-picture");
  const _component_logic = _resolveComponent("logic");
  const _component_com_popup = _resolveComponent("com-popup");
  return _openBlock(), _createElementBlock("div", {
    class: "allwh",
    onTouchstart: _cache[1] || (_cache[1] = (...args) => $options.start && $options.start(...args))
  }, [_createElementVNode("div", _hoisted_1, [$data.isIframe ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "set",
    style: _normalizeStyle({
      'background-color': $data.setting.bgColor,
      opacity: $data.setting.opacty,
      backgroundImage: 'url(' + $data.setting.bgpicture + ')'
    })
  }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.urls ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.urls,
    class: "urlsP",
    alt: ""
  }, null, 8, _hoisted_5)])) : _createCommentVNode("", true), !$data.urls ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.contents, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      id: item.hrefid,
      key: index,
      class: "list"
    }, [item.text === '标题' ? (_openBlock(), _createBlock(_component_title_assembly, {
      key: 0,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '富文本' ? (_openBlock(), _createBlock(_component_rich_assembly, {
      key: 1,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '图片' ? (_openBlock(), _createBlock(_component_picture_assembly, {
      key: 2,
      hrefs: $data.contents,
      content: item.setStyle,
      onOpenWechat: $options.openWechat,
      onArousePop: $options.arousePop,
      onJumpKf: $options.jumpKf,
      onGoHuoke: $options.goHuoke,
      tid: $data.tid,
      urlParams: $data.urlParams
    }, null, 8, ["hrefs", "content", "onOpenWechat", "onArousePop", "onJumpKf", "onGoHuoke", "tid", "urlParams"])) : _createCommentVNode("", true), item.text === '组图' ? (_openBlock(), _createBlock(_component_graph_assembly, {
      key: 3,
      hrefs: $data.contents,
      content: item.setStyle,
      onOpenWechat: $options.openWechat,
      onArousePop: $options.arousePop
    }, null, 8, ["hrefs", "content", "onOpenWechat", "onArousePop"])) : _createCommentVNode("", true), item.text === '图集' ? (_openBlock(), _createBlock(_component_atlas_assembly, {
      key: 4,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '视频' ? (_openBlock(), _createBlock(_component_video_assembly, {
      key: 5,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '表单' ? (_openBlock(), _createBlock(_component_form_assembly, {
      key: 6,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '电话' ? (_openBlock(), _createBlock(_component_telephone_assembly, {
      key: 7,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text === '微信包' ? (_openBlock(), _createBlock(_component_qrcode_assembly, {
      key: 8,
      tid: $data.tid,
      "page-type": $data.pageType,
      content: item.setStyle,
      "model-type": $data.modelType,
      onUserwechatid: $options.userwechatid,
      onHandleCanvas: $options.handleCanvas
    }, null, 8, ["tid", "page-type", "content", "model-type", "onUserwechatid", "onHandleCanvas"])) : _createCommentVNode("", true), item.text === '悬浮图片' ? (_openBlock(), _createBlock(_component_popup_picture, {
      key: 9,
      content: item.setStyle,
      onOpenWechat: $options.openWechat
    }, null, 8, ["content", "onOpenWechat"])) : _createCommentVNode("", true), item.text === '逻辑问答' ? (_openBlock(), _createBlock(_component_logic, {
      key: 10,
      content: item.setStyle,
      onOpenWechat: $options.openWechat,
      onOpenUrlLink: $options.openUrlLink,
      onGoHuoke: $options.goHuoke,
      onJumpCustomerAcquisition: $options.jumpCustomerAcquisition
    }, null, 8, ["content", "onOpenWechat", "onOpenUrlLink", "onGoHuoke", "onJumpCustomerAcquisition"])) : _createCommentVNode("", true)], 8, _hoisted_7);
  }), 128))])) : _createCommentVNode("", true)], 512)])], 512), false ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "my-support",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toSupport && $options.toSupport(...args))
  }, _hoisted_9)) : _createCommentVNode("", true), _createVNode(_component_com_popup, {
    ref: "comPopup",
    tid: $data.tid,
    popcontent: $data.popcontent,
    popsetting: $data.popsetting
  }, null, 8, ["tid", "popcontent", "popsetting"])], 32);
}